import { render, staticRenderFns } from "./SelectAbroad.vue?vue&type=template&id=02237ce0"
import script from "./SelectAbroad.vue?vue&type=script&lang=js"
export * from "./SelectAbroad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports